<section class="core-capabilities" aria-labelledby="core-capabilities-title">
  <div class="core-capabilities--container">
    <div class="core-capabilities--header">
      <span class="core-capabilities--accent" aria-hidden="true"></span>
      <h2 id="core-capabilities-title" class="core-capabilities--title">Core Capabilities of MahaAgX</h2>
      <span class="core-capabilities--line" aria-hidden="true"></span>
    </div>

    <div class="core-capabilities--grid">
      @for (cap of capabilities; track cap.id) {
        <article class="capability-card">
          <div class="capability-card--icon">
            <img [src]="cap.icon" [alt]="cap.title" class="capability-card--icon-img" />
          </div>
          <div class="capability-card--text">
            <h3 class="capability-card--title">{{ cap.title }}</h3>
            <p class="capability-card--description">{{ cap.description }}</p>
          </div>
        </article>
      }
    </div>
  </div>
</section>
